import React from 'react'
import OffLine from '../off-line'

const OffLineNo = () => {
    return <OffLine languageCode="no" />
}

export default OffLineNo
